// Ce service existe aussi dans le  back. Ne pas oublier de le changer si changement ici.
// import moment from 'moment/moment';
import * as niveauDispo from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import moment from 'moment/moment';

export function disponibiliteFaceNumeriqueGetter(face, dateStart, dateEnd) {
  if (face === null ||
    dateStart === null || !dateStart.isValid() ||
    dateEnd === null || !dateEnd.isValid() ||
    dateStart > dateEnd) {
    return niveauDispo.DISPONIBILITE_INDEFINI;
  }
  if (face.disponibilite === null || face.disponibilite.length === 0) {
    return niveauDispo.NON_DISPONIBLE;
  }
  const dispoTraitement = face.disponibilite.filter(
    el => moment(el.date) <= dateEnd.startOf('day') && moment(el.date) >= dateStart.startOf('day'));
  if (dispoTraitement.length === 0) return niveauDispo.NON_DISPONIBLE;
  const minDispo = dispoTraitement.map(el => el.niveauDisponibilite);
  return Math.min(...minDispo);
}

export function disponibiliteRavFaceNumeriqueGetter(face, dateStart, dateEnd) {
  if (face === null ||
    dateStart === null || !dateStart.isValid() ||
    dateEnd === null || !dateEnd.isValid() ||
    dateStart > dateEnd) {
    return niveauDispo.DISPONIBILITE_INDEFINI;
  }
  const dispoTraitement = face.disponibilite.filter(
    el => moment(el.date) <= dateEnd.startOf('day') && moment(el.date) >= dateStart.startOf('day'));
  return dispoTraitement.reduce((acc, val) => acc + (val.stock - val.vendu), 0);
}



// WEBPACK FOOTER //
// ./src/services/catalogue/disponibiliteFaceNumeriqueGetter.js